module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0